export class KafkaMessageSample {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "partition",
            "baseName": "partition",
            "type": "number",
            "format": ""
        },
        {
            "name": "offset",
            "baseName": "offset",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tsMs",
            "baseName": "tsMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "headers",
            "baseName": "headers",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "keyBytesB64",
            "baseName": "keyBytesB64",
            "type": "string",
            "format": ""
        },
        {
            "name": "keyParsed",
            "baseName": "keyParsed",
            "type": "ParsedValue",
            "format": ""
        },
        {
            "name": "valueBytesB64",
            "baseName": "valueBytesB64",
            "type": "string",
            "format": ""
        },
        {
            "name": "valueParsed",
            "baseName": "valueParsed",
            "type": "ParsedValue",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaMessageSample.attributeTypeMap;
    }
    constructor() {
    }
}
